export default "__VITE_ASSET__rCEoqlPN__"